import { useEffect, useState } from 'react';

/**
 * Appends a Google fonts link to the body from a comma separated list of font families.
 * @param {*} fonts 
 */
const useGoogleFonts = (fonts) => {

  const createLink = (fontString) => {
    
    if (!fontString || typeof fontString !== "string") {
      return;
    }

    const fontFamilies = fontString.replace(/ +/g, '+').replace(',', '|');

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css?family=${fontFamilies}`;

    return link;
  };

  const [link, setLink] = useState(null);

  useEffect(() => {
    if (!link) return;

    document.head.appendChild(link);

    return () => document.head.removeChild(link);
  }, [link]);

  useEffect(() => {
    setLink(createLink(fonts));
  }, [fonts]);

  return null;

};

export default useGoogleFonts;
